var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fieldset", { staticClass: "checkbox" }, [
    _c(
      "span",
      {
        staticClass: "checkbox-area",
        class: {
          "checkbox-area--block": _vm.block
        }
      },
      [
        _c("input", {
          attrs: {
            type: "checkbox",
            id: _vm.uniqueId,
            name: _vm.name,
            required: _vm.required,
            disabled: _vm.disabled,
            autocomplete: "off"
          },
          domProps: { value: _vm.value, checked: _vm.checked },
          on: { change: _vm.onChange }
        }),
        _vm._v(" "),
        _c(
          "label",
          { attrs: { for: _vm.uniqueId } },
          [
            _vm._t("default", function() {
              return [
                _c("span", {
                  directives: [
                    {
                      name: "sanitize",
                      rawName: "v-sanitize",
                      value: _vm.label,
                      expression: "label"
                    }
                  ]
                })
              ]
            })
          ],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }